import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import cn from "classnames";
import packageInfo from "../../../package.json";
import Keypad from "../../common/icons/Keypad";
import QR from "../../common/icons/QR";
import CallResident from "../../common/icons/CallResident";
import CallManager from "../../common/icons/CallManager";
import {
  STRINGS,
  NORMALIZED_BUTTONS,
  SK_MODEL,
  SK_MODELS,
  NormalizedButtonEvent,
} from "../../common/normalized-hardware-models";
import { Device } from "../../common/types";
import { RootState, History } from "src";

type ComponentProps = {
  history: History;
  device: Device;
  isShowingNotifications: boolean;
  hasPropertyPhone: boolean;
  propertyName?: string;
  isOnline: boolean;
  propertyDataLoading: boolean;
};
type ComponentState = {};

class Home extends Component<ComponentProps, ComponentState> {
  componentDidMount() {
    window.addEventListener("normalizedButtonEvent", this.handleButton);
  }

  componentWillUnmount() {
    window.removeEventListener("normalizedButtonEvent", this.handleButton);
  }

  handleButton = (e: NormalizedButtonEvent) => {
    const { history, device, isShowingNotifications, hasPropertyPhone } =
      this.props;
    if (isShowingNotifications) {
      return false;
    } else if (
      device.enable_resident_directory &&
      (e.detail.button === NORMALIZED_BUTTONS.UP ||
        e.detail.button === NORMALIZED_BUTTONS.DOWN)
    ) {
      history.replace("/resident-directory");
    } else if (
      device.enable_qr_codes &&
      e.detail.button === NORMALIZED_BUTTONS.GO
    ) {
      history.replace("/scan-qr");
    } else if (
      device.enable_call_manager &&
      hasPropertyPhone &&
      e.detail.button === NORMALIZED_BUTTONS.BACK
    ) {
      history.replace("/call");
    } else if (
      device.enable_numeric_codes &&
      Number.isInteger(e.detail.button)
    ) {
      history.replace(`/enter-code?initialCode=${e.detail.button}`);
    }
  };

  render() {
    const {
      propertyName,
      device,
      isOnline,
      hasPropertyPhone,
      propertyDataLoading,
    } = this.props;

    const rowContainerClasses = cn(
      "row-container",
      SK_MODEL === SK_MODELS.TOUCH && "touch"
    );
    const rowClasses = cn("row", SK_MODEL === SK_MODELS.TOUCH && "touch");

    return (
      <div className="wrapper">
        <h1 className="whenVertical page-title">Welcome to {propertyName}!</h1>
        <div className={rowContainerClasses}>
          <div className={rowClasses}>
            {device.enable_numeric_codes && (
              <Link className="iconLink" to="/enter-code">
                <div className="iconWrapper">
                  <Keypad />
                  <h2>{STRINGS.CODE_INPUT_LABEL}</h2>
                </div>
              </Link>
            )}
            {device.enable_qr_codes && (
              <Link className="iconLink" to="/scan-qr">
                <div className="iconWrapper">
                  <QR />
                  <h2>{STRINGS.SCAN_QR_LABEL}</h2>
                </div>
              </Link>
            )}
          </div>
          <div className={rowClasses}>
            {isOnline && device.enable_resident_directory && (
              <Link className="iconLink" to="/resident-directory">
                <div className="iconWrapper">
                  <CallResident />
                  <h2>{STRINGS.CALL_RESIDENT_LABEL}</h2>
                </div>
              </Link>
            )}
            {isOnline && device.enable_call_manager && hasPropertyPhone && (
              <Link className="iconLink" to="/call">
                <div className="iconWrapper">
                  <CallManager />
                  <h2>{STRINGS.CALL_MANAGER_LABEL}</h2>
                </div>
              </Link>
            )}
          </div>
        </div>
        <div className="footer">
          <div>
            {packageInfo.version} {propertyDataLoading && " ..."}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  propertyName: state.property.meta?.public_name,
  device: state.property.device,
  isOnline: state.app.isOnline,
  isShowingNotifications: state.app.notifications.length > 0,
  hasPropertyPhone: !!state.property.meta?.phone,
  propertyDataLoading: state.property.loading,
});

export default connect(mapStateToProps)(Home);
